import { useEffect, useRef } from 'react';
import { CheckCircle2 } from 'lucide-react';

type AdminSuccessBannerProps = {
    message: string | null;
    onDismiss?: () => void;
    /** Auto-dismiss delay in ms. Default 4000. Pass 0 to disable. */
    durationMs?: number;
};

/** Banner de éxito temporal (mismo patrón que Suscripciones). */
export function AdminSuccessBanner({
    message,
    onDismiss,
    durationMs = 4000,
}: AdminSuccessBannerProps) {
    const onDismissRef = useRef(onDismiss);
    onDismissRef.current = onDismiss;

    useEffect(() => {
        if (!message || durationMs <= 0) return;
        const timer = setTimeout(() => onDismissRef.current?.(), durationMs);
        return () => clearTimeout(timer);
    }, [message, durationMs]);

    if (!message) return null;

    return (
        <div
            role="status"
            className="bg-emerald-500/10 border border-emerald-500/30 rounded-xl px-4 py-3 text-sm text-emerald-400 flex items-center gap-2 animate-in fade-in slide-in-from-top-2"
        >
            <CheckCircle2 size={16} className="shrink-0" aria-hidden />
            <span>{message}</span>
        </div>
    );
}
